import React from "react"
import { twMerge } from "tailwind-merge"

import { practitionerWebsiteUrl } from "../../../@core/practitioner/practitioner.utils"
import ReviewStars from "../../../components/shared/ReviewStars"
import Typography from "../../../components/shared/Typography"

const ReviewCard = ({ review, className }) => {
  const isAnonymous = review.isAnonymous
  const reviewText = review.review?.trim() || review.text?.trim() || ""
  const name = review.client?.firstName || review.user?.firstName || review.unverifiedName || ""
  const lastName = review.client?.lastName || review.user?.lastName || ""
  const safeName =
    name != null && String(name).trim() !== "" && String(name).trim().toLowerCase() !== "undefined" ? String(name) : ""
  const safeLast = lastName != null && String(lastName).trim().toLowerCase() !== "undefined" ? String(lastName) : ""
  const firstName = (safeName && safeName.split(" ")[0]) || ""
  const firstInitial = firstName ? `${firstName[0]}.`.toUpperCase() : ""
  const lastNameDisplay = safeLast || (safeName && safeName.split(" ")[1]) || ""
  const displayName = isAnonymous
    ? "Anonymous"
    : [firstInitial, lastNameDisplay].filter(Boolean).join(" ").trim() || "Anonymous"
  const timeAgo = review.createdAtAgoInWords || review.timeAgo || "recently"

  return (
    <a
      href={review.practice ? practitionerWebsiteUrl(review.practice.user, review.practice) : "#"}
      className={twMerge(
        "flex min-h-[301px] w-full min-w-[345px] max-w-[600px] flex-col gap-4 rounded-xl border border-gray-light bg-white p-6 transition-opacity duration-700 ease-in-out focus-within:border-[3px] focus-within:border-blue hover:border-gray hover:shadow-[0px_8px_24px_rgba(11,57,84,0.08)]",
        className
      )}>
      {/* Review Text */}
      <div className="flex-1">
        <Typography variant="body" className="line-clamp-4 text-black">
          &ldquo;{reviewText}&rdquo;
        </Typography>
      </div>

      {/* Stars and Client Info */}
      <div className="flex flex-wrap items-center gap-2">
        <Typography variant="small" className="text-gray-dark">
          {displayName} • {timeAgo}
        </Typography>
        <div className="flex items-center gap-0.5">
          <ReviewStars rating={review.rating || 5} size="sm" />
        </div>
      </div>

      {/* Mini Profile */}
      {review.practice && (
        <div className="flex flex-col gap-4">
          <div className="h-px w-full border-t border-gray-light bg-white" />
          <div className="flex items-start gap-2">
            <img
              src={review.practice.user?.smallPhotoUrl || "/images/placeholder-avatar.jpg"}
              alt={review.practice.user?.name || "Practitioner"}
              className="size-10 shrink-0 rounded-full object-cover"
            />
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="flex items-center gap-1">
                <Typography variant="small" className="font-bold text-black">
                  {review.practice.user?.name || "Practitioner"}
                </Typography>
                <img className="size-5 shrink-0" src="/images/email/verified.png" alt="Verified" />
              </div>
              <Typography variant="small" className="truncate text-gray-dark">
                {review.practice.user?.title || ""}
              </Typography>
            </div>
          </div>
        </div>
      )}
    </a>
  )
}

export default ReviewCard
